import { analytics } from '@/firebase';
import { logEvent } from 'firebase/analytics';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    // Usa `beforeEnter` per eseguire un redirect a un dominio esterno
    beforeEnter() {
      if (window.location.search.includes('mode=resetPassword')) {
        window.location.href = 'https://app.cosmicup.me/reset-password' + window.location.search;
      } else if(window.location.search.includes('mode=verifyEmail')) {
        // go to current mail url, add '/tool' and window location search
        window.location.href = window.location.origin + '/tool' + window.location.search;
      } else {
        window.location.href = window.location.origin + '/login';
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/tool',
    name: 'tool',
    component: () => import('../views/ToolView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/chatgpt',
    name: 'chatgpt',
    beforeEnter() {
      window.location.href = 'https://app.cosmicup.me/tool';
    }
  },
  {
    path: '/claude',
    name: 'claude',
    beforeEnter() {
      window.location.href = 'https://app.cosmicup.me/tool';
    }
  },
  {
    path: '/gpt-chat',
    name: 'gpt-chat',
    component: () => import('../views/LandingChatView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  logEvent(analytics, 'page_view', {
    page_path: to.fullPath,
    page_title: to.name || 'unknown', // Usa il nome della route o imposta un valore di default
  });
  if(to.path === '/reset-password' || 
    (to.path === '/' && !window.location.search.includes('mode')) || 
    to.path === '/login'
  ){
    const auth = getAuth();
    const user = await new Promise((resolve) => {
      onAuthStateChanged(auth, (currentUser) => resolve(currentUser));
    });
    if(user){
      next('/tool');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
